<!-- Pick friends with checkboxes — for a new group and for adding people to
     one. Name first, number under it (the display rule). Real checkboxes in a
     fieldset, so a screen reader hears "Sam, 555-382-9104, checkbox". Screens
     role. -->
<template>
  <fieldset class="pm-scr-checklist">
    <legend class="pm-scr-label">{{ legend }}</legend>
    <p v-if="!friends.length" class="pm-scr-muted">{{ empty }}</p>
    <ul v-else class="pm-scr-rows">
      <li v-for="f in friends" :key="f.number" class="pm-scr-row">
        <label class="pm-scr-row-main pm-scr-check" :class="{ 'is-off': isFull && !picked(f.number) }">
          <input
            type="checkbox"
            class="pm-scr-check-box"
            :value="f.number"
            :checked="picked(f.number)"
            :disabled="isFull && !picked(f.number)"
            @change="toggle(f.number, $event.target.checked)"
          >
          <LcdChip :text="chipText(friendName(f.number))" />
          <span class="pm-scr-row-text">
            {{ friendName(f.number) }}
            <span v-if="friendSecondary(f.number)" class="pm-scr-muted pm-scr-small pm-scr-block">{{ friendSecondary(f.number) }}</span>
          </span>
        </label>
      </li>
    </ul>
    <p v-if="isFull" class="pm-scr-muted pm-scr-small">Groups are {{ MAX_GROUP }} pagers at most.</p>
  </fieldset>
</template>

<script setup>
import { computed } from 'vue';
import { friendName, friendSecondary, MAX_GROUP } from '../store.js';
import { chipText } from '../pm/format.js';
import LcdChip from './LcdChip.vue';

const props = defineProps({
  friends: { type: Array, default: () => [] },
  modelValue: { type: Array, default: () => [] },
  /** How many more can be picked. */
  room: { type: Number, default: MAX_GROUP - 1 },
  legend: { type: String, default: 'Who’s in it' },
  empty: { type: String, default: 'Add a friend first — groups are made from friends.' },
});
const emit = defineEmits(['update:modelValue']);

const picked = (n) => props.modelValue.includes(n);
const isFull = computed(() => props.modelValue.length >= props.room);

function toggle(n, on) {
  const next = props.modelValue.filter((x) => x !== n);
  if (on && next.length < props.room) next.push(n);
  emit('update:modelValue', next);
}
</script>
